import * as React from "react"
import { HeaderInterface, SpecificLink, LinkInterface } from "../config/interfaces";
import { DictionaryPage } from "../config/constants";

const THEMEURL = window.drupalSettings ? `/${window.drupalSettings.path.themeUrl}` : '/themes/custom/mx_aguas_firmes_theme';

const Languages: any = { es: 'Esp', en: 'Eng' }

export default ({ linkList, sponsors, lang }: HeaderInterface) => {
    const refHeader = React.useRef<any>(null)

    const [hamburgerActivate, setHamburgerActivate] = React.useState<boolean>(false)
    const [scrolled, setScrolled] = React.useState<boolean>()
    const [menuState, setMenuState] = React.useState<string>('')
    const [primaryLang, setPrimaryLang] = React.useState<string>('')
    const [secondaryLang, setSecondaryLang] = React.useState<string>('')
    const [registered, setregistered] = React.useState<boolean>(false)
    const [nameUSer, setnameUSer] = React.useState<string>('')

    const toggleMenu = (): void => {
        setHamburgerActivate(!hamburgerActivate)
        if (!hamburgerActivate == true) {
            setMenuState('af-header__section-menu--showing')
            fixedMenu(true)
            setTimeout(() => {
                setMenuState('af-header__section-menu--fixed')
            }, 300);
        }
        else {
            setMenuState('af-header__section-menu--hiding')
            fixedMenu(false)
            setTimeout(() => {
                setMenuState('')
            }, 300);
        }
    }

    const fixedMenu = (showedMenu: boolean): void => {
        if (showedMenu) document.body.style.overflow = 'hidden'
        if (!showedMenu) document.body.style.overflow = 'initial'
    }

    const changeHeader = () => {
        let logoList = document.querySelector('.sponsors__list') ? document.querySelector('.sponsors__list').getBoundingClientRect().y : refHeader.current.offsetHeight / 3
        let locationHeader = window.location.pathname.split('/').length <= 2 ? logoList : refHeader.current.offsetHeight / 3;

        window.addEventListener("scroll", function () {
            let isScrolled = window.scrollY >= locationHeader
            setScrolled(isScrolled)
        });
    }

    const changeLang = (e:any) => {
        e.preventDefault()
        
        let { currentUrl, indexLang } = getCurrentUrl()
        let pageKey = localStorage.getItem('currentPage')
        let nwPath = currentUrl

        // Change language
        let nwLang = currentUrl[indexLang] == 'es' ? 'en' : 'es'
        nwPath[indexLang] = nwLang
        
        // Change page name
        if (pageKey) {
            nwPath[indexLang + 1] = DictionaryPage[nwLang][pageKey]
            return window.location.replace(nwPath.join('/'))
        }

        window.location.replace(nwPath.join('/'))
    }

    const getCurrentUrl = (): { currentUrl: Array<string>, indexLang: number, currentLang: string } => {
        let currentUrl = window.location.pathname.split('/')
        let indexLang = currentUrl.findIndex((lang) => lang == 'es' || lang == 'en')

        return { currentUrl, indexLang, currentLang: currentUrl[indexLang] }
    }

    React.useEffect(() => {
        let { currentLang } = getCurrentUrl()
        setPrimaryLang(currentLang)
        setSecondaryLang(Languages[currentLang == 'es' ? 'en' : 'es'])
        document.addEventListener('DOMContentLoaded', () => {
            changeHeader()
        })

        //preguntamos si hay usuarios logueados
        const API_URL = window.location.protocol+`//`+window.location.host+'/es/user/logued';
        fetch(API_URL, {
            method: 'GET',
        })
        .then((response) => response.json())
        .then((response) => {
            setregistered(response.logued)
            if(response.logued){
                setnameUSer(response.name); 
                localStorage.setItem('nameUser', response.name)
            }else{
                localStorage.setItem('nameUser', '')
            }
        })
        .catch(function(error) {
        });

    }, [])

    const closeSesion = () =>{
        window.location.href = '/user/logout'
    }

    return (
        <div className={`af-header${scrolled ? ' af-header--scrolled' : ''}`} ref={refHeader}>
            <section className="af-header__container-top">
                <div className="af-info">
                    <p className="af-info__text">{lang == 'es' ? 'Un proyecto de' : 'A project by'}</p>
                    {sponsors.map((sponsor: SpecificLink, index: number) => (
                        <a href={sponsor.url} target={sponsor.target} key={index} rel="noopener"><img className="af-info__image" src={sponsor.description} alt={sponsor.title} title={sponsor.title} /></a>
                    ))}
                </div>
            </section>
            <div className="af-header__container">
                <section className="af-header__section-icon">
                    <a href={`/${primaryLang}`}><img src={`${THEMEURL}/sources/dist/assets/images/general/logo.png`} width="115" height="38" alt="Aguas Firmes" title="Aguas Firmes" /></a>
                </section>
                <section className={`af-header__section-menu ${menuState}`}>
                    <ul className="af-menu-list">
                        {linkList.map((link: LinkInterface, index: number) => (
                            <li className="af-menu-list__item" key={index}><a href={link.url} target={link.target}>{link.title}</a></li>
                        ))}
                        <li className="af-menu-list__item"><a type="button" href="javascript:;" onClick={changeLang}>{secondaryLang}</a></li>
                        <li className="af-menu-list__item">{registered ? 
                            <div><a href="/galeria">{nameUSer}</a><img src={`${THEMEURL}/sources/dist/assets/images/icons/log-out.png`} onClick={closeSesion} /> </div>: <a className="optSession" href="/inicio-sesion">Iniciar sesión</a> }</li>
                    </ul>
                    <div className="af-logo">
                        <p className="af-logo__text">{lang == 'es' ? 'Un proyecto de' : 'A project by'}</p>
                        <div className="af-logo__list">
                            {sponsors.map((sponsor: SpecificLink, index: number) => (
                                <a className="af-logo__item" href={sponsor.url} target={sponsor.target} key={index} rel="noopener"><img src={sponsor.description} alt={sponsor.title} title={sponsor.title} /></a>
                            ))}
                        </div>
                    </div>
                    <img className="af-menu-list__image" src={`${THEMEURL}/sources/dist/assets/images/general/menu-image.png`} alt="footerImage" title="footerImage" />
                </section>
                <section className="af-header__section-hamburguer">
                    <div className={`hamburgerBtn${hamburgerActivate ? ' active' : ''}`} onClick={toggleMenu}>
                        <span className="hamburgerBtn__line"></span>
                        <span className="hamburgerBtn__line"></span>
                        <span className="hamburgerBtn__line"></span>
                    </div>
                </section>
            </div>
        </div>
    )
}